import _get from "lodash/get";
import _set from "lodash/set";
import _cloneDeep from "lodash/cloneDeep";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import { RichTextElement } from "../RichTextElement/RichTextElement";
import { RichTextLeaf } from "../RichTextLeaf/RichTextLeaf";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var RichTextJSON = function RichTextJSON(_ref) {
  var json = _ref.json;
  // Parse the processed JSON string into a JavaScript object
  var value = RichTextJSON.parseJSON(json);
  if (!value) {
    return null;
  }
  var renderElement = function renderElement(element) {
    // Process children of the element as well.
    var elementChildren = element.children ? element.children.map(function (child, key) {
      var renderChild = _cloneDeep(child);
      _set(renderChild, 'attributes.key', key);
      return 'type' in renderChild ? renderElement(renderChild) : renderLeaf(renderChild);
    }) : null;
    return /*#__PURE__*/_jsx(RichTextElement, {
      element: element,
      attributes: element.attributes,
      children: elementChildren
    }, _get(element, 'attributes.key'));
  };
  var renderLeaf = function renderLeaf(leaf) {
    return /*#__PURE__*/_jsx(RichTextLeaf, {
      leaf: leaf,
      attributes: leaf.attributes,
      children: leaf.text
    }, _get(leaf, 'attributes.key'));
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: value.map(function (child, key) {
      var renderChild = _cloneDeep(child);
      _set(renderChild, 'attributes.key', key);
      return renderElement(renderChild);
    })
  });
};
var parseJSON = function parseJSON(str) {
  try {
    var value = JSON.parse(str);

    // The JSON value is valid if:
    //  1. It could be parsed.
    //  2. It is an array.
    //  3. All top level elements have types.
    if (value && Array.isArray(value) && value.every(function (element) {
      return element.type;
    })) {
      return value;
    }
    return null;
  } catch (ex) {
    return null;
  }
};
RichTextJSON.parseJSON = parseJSON;